import { Clock, MapPin, AlertOctagon } from "lucide-react";
import { SectionNumber } from "../visuals/SectionNumber";

export const Problem = () => {
    return (
        <section
            id="problem"
            data-testid="problem-section"
            className="relative bg-[#0A1428] text-white py-28 md:py-40 overflow-hidden"
        >
            <SectionNumber n={1} total={12} theme="dark" />
            <div className="absolute inset-0 dot-grid-light opacity-40 pointer-events-none" />
            <div className="absolute -top-40 -right-40 w-[600px] h-[600px] opacity-[0.08] pointer-events-none">
                <svg viewBox="0 0 200 200">
                    <polygon points="20,160 130,60 180,160" fill="#F0493E" />
                </svg>
            </div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-12">
                <div className="reveal">
                    <span className="text-xs md:text-sm font-bold uppercase tracking-[0.28em] text-[#F0493E]">
                        The Problem
                    </span>
                </div>

                <div className="mt-12 grid grid-cols-12 gap-x-8 gap-y-12 items-end">
                    <div className="col-span-12 lg:col-span-7 reveal">
                        <h2 className="font-display font-extrabold text-5xl md:text-7xl lg:text-[96px] leading-[0.95] tracking-tighter text-balance">
                            Emergency supplies
                            <br />
                            only help when
                            <br />
                            <span className="text-[#F0493E]">they&apos;re within reach.</span>
                        </h2>
                    </div>

                    <div className="col-span-12 lg:col-span-5 lg:pl-6 reveal">
                        <p className="text-lg md:text-xl text-slate-300 leading-relaxed font-medium">
                            In 2023 the FDA approved{" "}
                            <span className="text-white font-bold">
                                over-the-counter Naloxone
                            </span>{" "}
                            — making it available without a prescription.
                            Community access, however, is still uneven. Kairos
                            is building the distribution layer for OTC
                            emergency supplies, the way AEDs became standard
                            in public buildings.
                        </p>
                        <div className="mt-6 text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500">
                            Source · FDA, 2023
                        </div>
                    </div>
                </div>

                <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                    <ProblemStat
                        icon={Clock}
                        figure="24"
                        unit="/7"
                        label="Availability window a Kairos-equipped space provides for OTC emergency supplies."
                        testid="problem-stat-time"
                    />
                    <ProblemStat
                        icon={MapPin}
                        figure="OTC"
                        unit=""
                        label="Naloxone is now over-the-counter across the U.S. — no prescription required."
                        testid="problem-stat-place"
                    />
                    <ProblemStat
                        icon={AlertOctagon}
                        figure="60"
                        unit="sec"
                        label="Target time to reach a Kairos unit inside a covered facility."
                        testid="problem-stat-proximity"
                    />
                </div>
            </div>
        </section>
    );
};

const ProblemStat = ({ icon: Icon, figure, unit, label, testid }) => (
    <div
        data-testid={testid}
        className="bg-[#0A1428] p-8 md:p-10 reveal hover:bg-[#0d1a36] transition-colors"
    >
        <Icon size={26} strokeWidth={1.5} className="text-[#F0493E]" />
        <div className="mt-8 font-display font-extrabold text-5xl md:text-6xl tnum tracking-tighter">
            {figure}
            <span className="text-2xl md:text-3xl text-slate-400 font-bold ml-1">
                {unit}
            </span>
        </div>
        <p className="mt-5 text-sm md:text-base text-slate-400 leading-relaxed font-medium">
            {label}
        </p>
    </div>
);
